<template>
    <app-loader @success="onLoadSuccess" @error="onLoadError"/>
</template>

<script>

import AppLoader from '@/components/entrance/AppLoader'

export default {
    components: {
        AppLoader,
    },
    methods: {
        onLoadSuccess() {
            const vm = this
            console.log('success login')
            if (!vm.currentUser.emailVerified) return vm.$router.replace({name: 'confirm-mail'})
            if (!vm.accountType) return vm.$router.replace({name: 'select-profile'})
            if (vm.account.accountType === 'coach_company' && vm.account?.firstLogin === true) return vm.$router.replace({name: 'coach-company-invitation'})
            if (!vm.account.name && vm.account.accountType !== 'coach_company') return vm.$router.replace({name: 'basic-info'})
            if (vm.account.accountType === 'coach' || vm.account.accountType === 'company') {
                const hasStripeAccount = vm.account && vm.account.stripeAccount || null
                const hasPaymentMethod = hasStripeAccount && hasStripeAccount.paymentMethod && hasStripeAccount.paymentMethod.id || null
                const hasCurrentSubscription = hasStripeAccount && hasStripeAccount.currentSubscription && hasStripeAccount.currentSubscription.id || null
                const isFreeSubscription = hasStripeAccount && hasStripeAccount.currentSubscription && hasStripeAccount.currentSubscription.isFree === true
                if (!hasPaymentMethod && !isFreeSubscription) return vm.$router.replace({name: `${vm.accountType}.credit-card`})
                if (!hasCurrentSubscription) return vm.$router.replace({name: `${vm.accountType}.select-plan`})
            }
            return vm.goHome(true)
        },
        onLoadError() {
            const vm = this
            console.log('error load')
            vm.$router.replace({name: 'login'})
        }
    }
}

</script>